export default "__VITE_ASSET__CxEbuEx3__"